import { render, staticRenderFns } from "./InactiveAlert.vue?vue&type=template&id=42c6517c&scoped=true"
import script from "./InactiveAlert.vue?vue&type=script&lang=js"
export * from "./InactiveAlert.vue?vue&type=script&lang=js"
import style0 from "./InactiveAlert.vue?vue&type=style&index=0&id=42c6517c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c6517c",
  null
  
)

export default component.exports